export const getAutocompleteSelectionsFromIds = (values, ids) => {
  return ids.map((id) => values.find((value) => value.id === id))
}
